import React from "react";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../../core/et3-page-div";
import Et3PageTitle from "../../../../core/et3-page-title/index";
import getKhattabatMatchingStore from "../../../../stores/khattabat-stores/matching-store";
import getCoreHistoryStore from "../../../../stores/core/core-history-store";
import Form from "./form";
import CreateOneOOneM from "./create-101m";
import MatchesFoundCount from "./MatchesFoundCount";

const KhattabatSearchingAnd101M = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "KHATTABAT_MATCHING_SEARCH_AND_1O1M",
      "KHATTABAT_MATCHING_SEARCH_AND_1O1M"
    );
    getKhattabatMatchingStore().getPaidUsersInformation();
  });

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT_MATCHING_SEARCH_AND_1O1M")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <Form />
      <MatchesFoundCount />
      <CreateOneOOneM />
    </ET3PageDiv>
  );
});
export default KhattabatSearchingAnd101M;
